export default __webpack_public_path__ + "static/media/img-dryclean.145856f7.png";